import { Form } from "antd";
import styled, { css } from "styled-components";

import { Palette } from "../../../../core/styles/theme";

// TODO Styles must be set for the new FormManager component.
const StyledFormControlCss = css`
    .ant-row {
        display: grid;
        grid-template-columns: 1fr 2fr;
    }
    .ant-form-item-label {
        text-align: right;
        padding-right: 10px;
        padding-left: 10px;
        max-width: 200px;
        min-width: 100px;
    }

    // Moves red asterisk on required form fields from left to right side.
    .ant-form-item-label > label.ant-form-item-required:not(.ant-form-item-required-mark-optional) {
        &::before {
            display: none;
        }
        &::after {
            content: "*";
            display: inline-block;
            font-family: SimSun, sans-serif;
            color: ${Palette.AeviRed};
            line-height: 1;
        }
    }
`;

export const HorizontalFormFieldStyle = styled(Form.Item)`
    ${StyledFormControlCss}
`;
